module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("打印盘点单")]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "盘点库存",
      "name": "stock"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.checkDetail,
      "highlight-current-row": "",
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderID",
      "label": "单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReferenceID",
      "label": "来源单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总数/已盘点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_vm._v("\n                    " + _vm._s(s.row.Count.Quantity) + " / " + _vm._s(s.row.Count.Inventory) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Count.percent",
      "label": "盘点进度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_vm._v("\n                    " + _vm._s(s.row.Date)), _c('br'), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "gray"
          }
        }, [_vm._v(_vm._s(s.row.UpdateDate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleOpenSetting(s.row)
            }
          }
        }, [_vm._v("设置")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库属性"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "库存编码/包裹编码"
    },
    model: {
      value: (_vm.stockAttribute),
      callback: function($$v) {
        _vm.stockAttribute = $$v
      },
      expression: "stockAttribute"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "placeholder": "仓库列表"
    },
    model: {
      value: (_vm.stockSelect),
      callback: function($$v) {
        _vm.stockSelect = $$v
      },
      expression: "stockSelect"
    }
  }, _vm._l((_vm.stockList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": ((item.Code) + "  " + (item.Name))
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "库区"
    },
    model: {
      value: (_vm.stockArea),
      callback: function($$v) {
        _vm.stockArea = $$v
      },
      expression: "stockArea"
    }
  }, _vm._l((_vm.stockAreaList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": ((item.Code) + "  " + (item.Name))
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "所有库位"
    },
    model: {
      value: (_vm.stockArea),
      callback: function($$v) {
        _vm.stockArea = $$v
      },
      expression: "stockArea"
    }
  }, _vm._l((_vm.stockAreaList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": ((item.Code) + "  " + (item.Name))
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "货主"
    },
    model: {
      value: (_vm.owner),
      callback: function($$v) {
        _vm.owner = $$v
      },
      expression: "owner"
    }
  }, _vm._l((_vm.ownerList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": ((item.Code) + "  " + (item.Name))
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品属性"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "产品级别"
    },
    model: {
      value: (_vm.productRank),
      callback: function($$v) {
        _vm.productRank = $$v
      },
      expression: "productRank"
    }
  }, _vm._l((_vm.productRankList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": ((item.Code) + "  " + (item.Name))
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "SPU"
    },
    model: {
      value: (_vm.spu),
      callback: function($$v) {
        _vm.spu = $$v
      },
      expression: "spu"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name",
      "size": "small"
    },
    on: {
      "select": _vm.handleSelectSearch
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("增加盘点库存")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.mainList,
      "highlight-current-row": "",
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderID",
      "label": "库存"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "包含产品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return _vm._l((s.row.Package.Product), function(item) {
          return _c('span', {
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v("[" + _vm._s(item.FullSKU) + "]" + _vm._s(item.FullName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Quantity",
      "label": "目标在库数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Inventory",
      "label": "已盘点数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "TrueNam",
      "label": "操作同事"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "最后操作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.getCheckFlow(s.row)
            }
          }
        }, [_vm._v("查看操作流水")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleDeleteCheckStock(s.row.DataID)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "page-sizes": [20, 30, 50, 100],
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "流水",
      "name": "laundry"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.flowList,
      "highlight-current-row": "",
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderID",
      "label": "单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Quantity",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "width": "200"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "日志",
      "name": "log"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.logList,
      "highlight-current-row": "",
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "操作人",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "width": "200"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('cm-modal-simple', {
    attrs: {
      "show": _vm.modalShow,
      "title": '盘点单设置',
      "width": '700px',
      "diy-class": 'diy-setting'
    },
    on: {
      "close": _vm.modalClose
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('ul', {
    staticClass: "setting-ul"
  }, [_c('li', [_vm._v("盘点计划： " + _vm._s(_vm.setting.OrderID))]), _vm._v(" "), _c('li', [_vm._v("计划数量： " + _vm._s(_vm.setting.Quantity))]), _vm._v(" "), _c('li', [_vm._v("盘点数量： " + _vm._s(_vm.setting.Inventory))]), _vm._v(" "), _c('li', [_vm._v("状态情况： " + _vm._s(_vm.setting.Status))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "setting-info"
  }, [_c('p', [_vm._v("把盘点单设置为 “完成” 状态")]), _vm._v(" "), _c('p', [_vm._v("ERP会根据计划数量与盘点数量的情况，自动产生入库单和出库单，同时执行入库和出库的操作")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setCheckState('完成')
      }
    }
  }, [_vm._v("完成盘点")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setCheckState('取消')
      }
    }
  }, [_vm._v("取消盘点")])], 1)], 1)], 1), _vm._v(" "), _c('cm-modal-simple', {
    attrs: {
      "show": _vm.modalFlowShow,
      "title": '盘点库存流水',
      "width": '700px',
      "diy-class": 'diy-flow'
    },
    on: {
      "close": _vm.modalFlowClose
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.stockFlowList,
      "highlight-current-row": "",
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderID",
      "label": "单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Quantity",
      "label": "数量",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "width": "200"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07184696"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/check/checkDetail.vue
// module id = 828
// module chunks = 1